import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../Homepage/Homepage.css";

gsap.registerPlugin(ScrollTrigger);

const Homepage = () => {
  const imageSectionRef = useRef(null);
  const coverImageRef = useRef(null);

  useEffect(() => {
    gsap.timeline({
      scrollTrigger: {
        trigger: imageSectionRef.current,
        start: "top top",
        end: "+=500",
        scrub: true,
        pin: true,
        onUpdate: (self) => {
          const progress = self.progress;
          const clipValue = `${20 + progress * 80}%`; // 20% to 100%
          coverImageRef.current.style.clipPath = `circle(${clipValue} at 50% 50%)`;
        },
      },
    });
  }, []);
  return (
    <div className="homepage">
      {/* Image Section */}
      <section className="image-section" ref={imageSectionRef}>
        <div className="cover-image" ref={coverImageRef}>
          <img src="blog.webp" alt="Profile" className="profile-image" />
        </div>
      </section>

      {/* Next Section */}
      <section className="next-section">
        <h2>Welcome to the Next Section</h2>
        <p>Scroll back up to see the animation again!</p>
      </section>
    </div>
  );
};

export default Homepage;
